import { AppBar, Toolbar, Box, Select, MenuItem } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useLocale } from '../context/LocaleContext';
import CostcoLogo from '../assets/costco-logo.png';

const TopAppBar: React.FC = () => {
    const { locale, setLocale } = useLocale();
    
    // Extract language code for display (e.g., "en-US" -> "EN")
    const displayLanguage = locale.substring(0, 2).toUpperCase();

    return (
        <AppBar position="static" elevation={0} sx={{ backgroundColor: '#ffffff', color: 'inherit', borderBottom: '1px solid #e0e0e0' }}>
            <Toolbar sx={{ minHeight: 72, display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative' }}>
                {/* Centered logo container */}
                <Box sx={{ left: '50%', position: 'absolute', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', pointerEvents: 'none' }}>
                    <img src={CostcoLogo} alt="Costco" style={{ height: 40, width: 'auto', display: 'block' }} />
                </Box>
                
                {/* Language selector on the right */}
                <Box sx={{ marginLeft: 'auto', zIndex: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                    <LanguageIcon sx={{ color: '#2e7d32', fontSize: '1.5rem' }} />
                    <Select
                        value={locale}
                        onChange={(e) => setLocale(e.target.value)}
                        displayEmpty
                        disableUnderline
                        variant="standard"
                        sx={{
                            '& .MuiSelect-root': {
                                padding: 0,
                                color: '#2e7d32',
                            },
                            '& .MuiSelect-icon': { 
                                color: '#0a5' 
                            },
                            '& .MuiSelect-select': {
                                color: '#2e7d32',
                                backgroundColor: 'transparent',
                                fontWeight: 600,
                                fontSize: '0.95rem',
                                paddingRight: '24px !important',
                            },
                        }}
                    >
                        <MenuItem value="en-US" sx={{ color: '#0a5', fontWeight: 600 }}>
                            English
                        </MenuItem>
                        <MenuItem value="fr-CA" sx={{ color: '#0a5', fontWeight: 600 }}>
                            Français
                        </MenuItem>
                    </Select>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default TopAppBar;
